import { Size } from '../enums/size.enum';

interface BraModifiers {
  spillingOutCupUpModifier: boolean;
  gappingCupDownModifier: boolean;
  tightBandUpModifier: boolean;
  bandRidingUpDownModifier: boolean;
}

interface BraModifierResults {
  shouldUpsizeBand: boolean;
  shouldDownsizeBand: boolean;
  shouldUpsizeCup: boolean;
  shouldDownsizeCup: boolean;
}

export const getBraModifications = (modifiers: BraModifiers): BraModifierResults => {
  return {
    shouldUpsizeBand: shouldUpsizeBand(modifiers),
    shouldDownsizeBand: shouldDownsizeBand(modifiers),
    shouldUpsizeCup: shouldUpsizeCup(modifiers),
    shouldDownsizeCup: shouldDownsizeCup(modifiers),
  };
};

const shouldUpsizeBand = (modifiers: BraModifiers): boolean => {
  return modifiers.tightBandUpModifier && !modifiers.bandRidingUpDownModifier;
};

const shouldDownsizeBand = (modifiers: BraModifiers): boolean => {
  return !modifiers.tightBandUpModifier && modifiers.bandRidingUpDownModifier;
};

const shouldUpsizeCup = (modifiers: BraModifiers): boolean => {
  return modifiers.spillingOutCupUpModifier && !modifiers.gappingCupDownModifier;
};

const shouldDownsizeCup = (modifiers: BraModifiers): boolean => {
  return modifiers.gappingCupDownModifier && !modifiers.spillingOutCupUpModifier;
};

export const getDressSizeForVneckBra = (dress = -1): Size | undefined => {
  if (dress < 0) {
    return undefined;
  }
  if (dress <= 2) {
    return Size.XS;
  }
  if (dress <= 6) {
    return Size.S;
  }
  if (dress <= 10) {
    return Size.M;
  }
  if (dress <= 14) {
    return Size.L;
  }
  if (dress <= 16) {
    return Size.XL;
  }
  if (dress <= 18) {
    return Size['1X'];
  }
  if (dress <= 20) {
    return Size['2X'];
  }

  return Size['3X'];
};
